import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import price from '../../price';
import { useSFPrices } from './useSFPrices';

const normalizeValues = (items = []) =>
  items
    .map((item) => parseFloat(item && item.value))
    .filter((value) => !Number.isNaN(value) && value > 0);

export const usePriceUpdate = (formCtx, glassCompositions, markups) => {
  const prices = useSFPrices();
  const [widths, elevations, autoPrice, glassCompositionId] = useWatch({
    name: ['widths', 'elevations', 'autoPrice', 'glassCompositionId'],
    control: formCtx.control,
  });

  useEffect(
    () => {
      const normalizedWidths = normalizeValues(widths);
      const normalizedElevations = normalizeValues(elevations);
      const totalWidth = normalizedWidths.reduce((sum, width) => sum + width, 0);
      const totalHeight =
        normalizedElevations[normalizedElevations.length - 1] || 0;

      const storefrontPrice = price({
        type: 'sf',
        compositions: glassCompositions,
        markups,
        prices,
        autoPrice,
        price: 'default',
        glassCompositionId,
        width: totalWidth,
        lHeight: totalHeight,
        rHeight: totalHeight,
      });

      if (storefrontPrice !== 'default') formCtx.setValue('price', storefrontPrice);
    },
    [widths, elevations, autoPrice, prices, glassCompositionId]
  );
};
